import Stack from '@mui/material/Stack';
import { includes } from 'ramda';
import { useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { validationDisplayTypes } from '@gef-ui/form-material/constants';
import { getLabelMessage } from '@gef-ui/localization/messages';

import Agency from 'components/atoms/GefMui/OrganizationStructure/Agency';
import Channel from 'components/atoms/GefMui/OrganizationStructure/Channel';
import Manager from 'components/atoms/GefMui/OrganizationStructure/Manager';
import Region from 'components/atoms/GefMui/OrganizationStructure/Region';
import Seller from 'components/atoms/GefMui/OrganizationStructure/Seller';
import Sidebar from 'components/atoms/GefMui/Sidebar/Sidebar';
import { AUTO_FILL_RULES, EMPTY_VALUES, USER_ROLES } from 'constants/general';
import { MPU_DISPLAY_TASK_STATISTIC } from 'features/common/acl/constants';
import { FIELDS, TASK_STATISTICS_FORM_NAME } from 'features/views/taskStatistics/form';
import { getCurrentRole } from 'features/views/user/selectors';

const StatisticsSidebar = () => {
	const currentRole = useSelector(getCurrentRole);

	return (
		<Sidebar title={getLabelMessage('sidebar:organizationStructure')}>
			<AccessControl accessLevel={MPU_DISPLAY_TASK_STATISTIC}>
				<Stack sx={{ mt: 1, mx: 0.5 }} spacing={1}>
					<Channel
						fieldName={FIELDS.channel}
						formName={TASK_STATISTICS_FORM_NAME}
						disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.CENTRAL)}
						autoSelect={!includes(currentRole, AUTO_FILL_RULES.CENTRAL)}
						isGuarantor={currentRole === USER_ROLES.GUARANTOR}
						customAllowedChannels={EMPTY_VALUES.ARRAY}
						type="sidebar"
						validationDisplay={validationDisplayTypes.HIDDEN}
					/>
					<Region
						fieldName={FIELDS.region}
						formName={TASK_STATISTICS_FORM_NAME}
						disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.CENTRAL)}
						autoSelect={!includes(currentRole, AUTO_FILL_RULES.CENTRAL)}
						isGuarantor={currentRole === USER_ROLES.GUARANTOR}
						customAllowedRegions={EMPTY_VALUES.ARRAY}
						type="sidebar"
						validationDisplay={validationDisplayTypes.HIDDEN}
					/>
					<Agency
						fieldName={FIELDS.agency}
						formName={TASK_STATISTICS_FORM_NAME}
						autoSelect={!includes(currentRole, AUTO_FILL_RULES.REGION_MANAGER)}
						disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.REGION_MANAGER)}
						customAllowedAgencies={EMPTY_VALUES.ARRAY}
						type="sidebar"
						validationDisplay={validationDisplayTypes.HIDDEN}
					/>
					<Manager
						fieldName={FIELDS.manager}
						formName={TASK_STATISTICS_FORM_NAME}
						autoSelect={!includes(currentRole, AUTO_FILL_RULES.AGENCY_MANAGER)}
						disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.AGENCY_MANAGER)}
						customAllowedManagers={EMPTY_VALUES.ARRAY}
						type="sidebar"
						validationDisplay={validationDisplayTypes.HIDDEN}
					/>
					<Seller
						fieldName={FIELDS.seller}
						formName={TASK_STATISTICS_FORM_NAME}
						autoSelect={!includes(currentRole, AUTO_FILL_RULES.SELLER)}
						disableOnOneOptions={!includes(currentRole, AUTO_FILL_RULES.SELLER)}
						customAllowedSellers={EMPTY_VALUES.ARRAY}
						type="sidebar"
						validationDisplay={validationDisplayTypes.HIDDEN}
					/>
				</Stack>
			</AccessControl>
		</Sidebar>
	);
};

export default StatisticsSidebar;
